/* eslint-disable @typescript-eslint/indent */

import React, { useContext } from 'react';
import { useEffect } from 'react';

import { FormContext } from 'contexts';

import { AuDirectionLink, AuHeading } from 'components/DTA';

import { ExitModal } from '../../CASAForm/ExitModal';


import styles from './StepContainer.module.scss';

interface IStepContainerProps {
    title?: string;
    hidePreviousLink?: boolean;
    customHandleBack?: (e: React.MouseEvent<HTMLElement>) => void;
}

const StepContainer: React.FC<IStepContainerProps> = ({ title, hidePreviousLink = false, children, customHandleBack: customHandleBack }) => {
    const { handleBack, cleanup, clickListener, modal, url, setModal } = useContext(FormContext);
    const handleBackAction = customHandleBack ? customHandleBack : handleBack;

    useEffect(() => {
        window.addEventListener('beforeunload', () => cleanup(clickListener));
        document.querySelectorAll('a').forEach(item => {
            if (item.href != 'https://www.casa.gov.au/about-us/who-we-are/about-casa/privacy-statement') {
                item.addEventListener('click', clickListener);
            }
        });
    });

    const toggle = (e) => {
        e.preventDefault();

        setModal(!modal);
    };

    //when user confirms exit then return to url in clicked link
    const OK = (e) => {
        e.preventDefault();

        setModal(!modal);

        if (location) {
            location.href = url ? url : '/';
        }
    };

    const exitModalParams = {
        isOpen: modal,
        toggleFunction: toggle,
        OKFunction: OK
    };

    return (
        <div className={styles.container}>

            <ExitModal exitModalParams={exitModalParams} />

            {
                hidePreviousLink === false &&
                <AuDirectionLink direction='left' text='Back' onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault(); // back button does not need to submit the form
                    handleBackAction(e);
                }} />
            }

            <AuHeading className={styles.stepTitle} level='2'>{title}</AuHeading>
            {children}
        </div>
    );
};

export default StepContainer;
